/*
 * Compact PDP gallery "View all" (sections/main-product.liquid): shows the
 * collage items held back behind the button, in place. The zoom viewer is not
 * used because it holds photos only. Loaded only when items are held back.
 */
if (!customElements.get('compact-gallery-more')) {
  customElements.define('compact-gallery-more', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (this.button) this.button.addEventListener('click', () => this.expand());
    }

    expand() {
      const collage = this.closest('.product-media-collage');
      if (!collage) return;
      const held = [...collage.querySelectorAll('.product-media-collage__item--more')];
      held.forEach((item) => item.classList.remove('product-media-collage__item--more'));
      collage.classList.add('product-media-collage--expanded');
      this.button.setAttribute('aria-expanded', 'true');

      // The button goes away, so give focus to the first item it revealed.
      const first = held[0];
      this.hidden = true;
      if (first) {
        const target = first.querySelector('a[href], button, [tabindex]:not([tabindex="-1"])') || first;
        if (target === first) first.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      }
    }
  });
}
